var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c("hosting-password", {
            attrs: {
              hostingid: _vm.hosting.id,
              title: "Change Password for ".concat(_vm.hostingDomain, ":")
            },
            scopedSlots: _vm._u([
              {
                key: "before-password",
                fn: function fn() {
                  return [
                    _c(
                      "v-col",
                      {
                        attrs: {
                          cols: "12"
                        }
                      },
                      [
                        _c(
                          "p",
                          {
                            staticClass: "mb-0"
                          },
                          [
                            _vm._v("This will change the password for "),
                            _c("b", [_vm._v(_vm._s(_vm.hostingDomain))]),
                            _vm._v(".")
                          ]
                        )
                      ]
                    )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }